import dayjs from 'dayjs';
import React from 'react';
import Typography from '../../components/Typography';
import { translate } from '../../i18n';
import { ITranslations } from '../../i18n/config';

interface ACardHistoryItemProps {
  data: Api.ACardHistoryItem;
}

const ACardHistoryItem: React.FC<ACardHistoryItemProps> = ({ data }) => {
  let translation = translate(`acard.history.type.${data.type}` as ITranslations, {
    locatie: data.location as string,
    voordeel: data.extra as string,
    statuut: data.extra as string,
    roepnaam: data.callName as string,
    familienaam: data.surName as string,
  });

  if (
    (data.type === 'create-reward' ||
      data.type === 'redeem-cheque' ||
      data.type === 'redeem-benefit' ||
      data.type === 'undo-redeem-cheque' ||
      data.type === 'redeem-statute') &&
    !data.location?.trim()
  ) {
    translation = translation.replace(/ bij/g, '');
  }

  return (
    <div>
      <Typography>
        <strong>{translation}</strong>
      </Typography>
      <p>
        <small>{dayjs(data.date).format('DD/MM/YYYY HH:mm')}</small>
      </p>
    </div>
  );
};

export default ACardHistoryItem;
